import { HttpTimeoutError } from '../types/http-timeout-error';
import { withTimeout } from './with-timeout';
export const withPoll = async (fn, pollingConfiguration, requestTimeoutInMilliseconds) => {
    const cumulativeRequestsTimeoutInMilliseconds = pollingConfiguration.cumulativeRequestsTimeoutInMilliseconds || 30000;
    const endTime = new Date().getTime() + cumulativeRequestsTimeoutInMilliseconds;
    let waitTime = pollingConfiguration.waitTimeInMilliseconds || 1000;
    return withTimeout(async () => {
        const innerPoll = async () => {
            const response = await withTimeout(() => fn(), requestTimeoutInMilliseconds);
            if (await pollingConfiguration.predicate(response)) {
                return response;
            }
            else if (new Date().getTime() + waitTime < endTime) {
                await new Promise(resolve => {
                    setTimeout(resolve, waitTime);
                });
                if (pollingConfiguration.exponentialWaitTime) {
                    waitTime *= 2;
                }
                return innerPoll();
            }
            throw new HttpTimeoutError();
        };
        return innerPoll();
    }, cumulativeRequestsTimeoutInMilliseconds);
};
//# sourceMappingURL=with-poll.js.map